/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
	if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
	if (hasClass(ele, cls)) {
		const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
		ele.className = ele.className.replace(reg, ' ')
	}
}

export function hasClass(ele, cls) {
	return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}
// 供应商信息分类
export function gysInfoFilter(info){
	let res = {
		QYXX:null,
		YWXX:null,
		// GHLB:null,
		// LXRXX:null,
		// DZXX:null,
		// YHXX:null,
		KPXX:null,
		// CWXX:null,
		// GSFJ:null,
	}
	// createTime: "2021-11-04 15:27:57"
	// createUser: 1
	// id: 13
	// status: 1
	// 企业信息
	if(info.tyShXxCode){
		res.QYXX = {
			tyShXxCode:info.tyShXxCode,
			name:info.name,
			englishName:info.englishName,
			qyShort:info.qyShort,
			orgJgCode:info.orgJgCode,
			dbsCode:info.dbsCode,
			rzRegion:info.rzRegion,
			qyTyoe:info.qyTyoe,
			taxpayerSign:info.taxpayerSign,
			country:info.country,
			legalPerson:info.legalPerson,
			zcCapital:info.zcCapital,
			zcCurrency:info.zcCurrency,
			foundDate:info.foundDate,
			yyZzSrc:info.yyZzSrc,
			manageArea:info.manageArea,
			address:info.address,
		}
	}
	// 业务信息
	if(info.zyClass){
		res.YWXX = {
			zySf:info.zySf,
			jyXz:info.jyXz,
			hyType:info.hyType,
			shFwScope:info.shFwScope,
			gsGw:info.gsGw,
			gsLogoSrc:info.gsLogoSrc,
			zyClass:info.zyClass,
			gsDetail:info.gsDetail,
		}
	}
	// 开票信息
	if(info.invoiceHead){
		res.KPXX = {
			invoiceHead:info.invoiceHead,
			swDjh:info.swDjh,
			khhName:info.khhName,
			khhNumber:info.khhNumber,
			swDjDz:info.swDjDz,
			swDjDh:info.swDjDh,
			sprEmail:info.sprEmail,
			sprDh:info.sprDh,
		}
	}
	// 经营类别
	return res
};

// 高精度运算
// const a = 9.99;
// const b = 8.03;
// // 加法
// let c = new Decimal(a).add(new Decimal(b)).toNumber()
// // 减法
// let d = new Decimal(a).sub(new Decimal(b)).toNumber()
// // 乘法
// let e = new Decimal(a).mul(new Decimal(b)).toNumber()
// // 除法
// let f = new Decimal(a).div(new Decimal(b)).toNumber()
import { Decimal } from '@/utils/decimal.js'
export function decimalUtil(type,a,b,fixed){
	let re = '';
	if(type == 'add'){
		re = new Decimal(a).add(new Decimal(b)).toNumber();
	}
	if(type == 'sub'){
		re = new Decimal(a).sub(new Decimal(b)).toNumber();
	}
	if(type == 'mul'){
		re = new Decimal(a).mul(new Decimal(b)).toNumber();
	}
	if(type == 'div'){
		re = new Decimal(a).div(new Decimal(b)).toNumber();
	}
	if(fixed){
		re = re.toFixed(fixed)
	}
	return re
}

export function createHash () {
    let hashLength = 16;
    var ar = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
    var hs = [];
    var hl = Number(hashLength);
    var al = ar.length;
    for (var i = 0; i < hl; i ++) {
        hs.push(ar[Math.floor(Math.random() * al)]);
    }

    return hs.join('');
}

export function getBaseImgUrl () {
	if(window.location.origin.indexOf('localhost')>=0){
		return 'http://127.0.0.1:9999'
	}else{
		return '/api'
	}

}
